<template lang="pug">
  .welcome
    VideoBanner
    .row
      FixedWidthTweakUpper
        SectionBlock(no-padding=true)
          ColorMatchSwatchSelector
          HomeCtas

        SectionBlock(v-if="cart.addons.length > 0")
          ReturnVisitorXsell

        SectionBlock(no-padding=true)
          UGCBanner
          ReviewCarousel

</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import SectionBlock from '../../SectionBlock';
  import VideoBanner from './VideoBanner';
  import ColorMatchSwatchSelector from './ColorMatchSwatchSelector';
  import HomeCtas from './HomeCtas';
  import UGCBanner from './UGCBanner';
  import ReviewCarousel from './ReviewCarousel';
  import FixedWidthTweakUpper from "../../../FixedWidthTweakUpper";
  import ReturnVisitorXsell from "./ReturnVisitorXsell/ReturnVisitorXsell";

  export default {
    name: "ReturnVisitor",

    components: {
      ReturnVisitorXsell,
      FixedWidthTweakUpper,
      SectionBlock,
      VideoBanner,
      ColorMatchSwatchSelector,
      HomeCtas,
      UGCBanner,
      ReviewCarousel
    },

    computed: {
      ...mapState('cart', ['cart'])
    },

    methods: {
      ...mapActions('cart', ['loadCart']),
    },

    mounted() {
      this.loadCart();
    }
  }
</script>
